<template>
  <div
    class="d-flex d-flex-initial drop-area"
    :class="{ 'drop-area-scrollable': scrollable }"
  >
    <template v-if="type === 'image'">
      <div class="img" v-for="v in value" :key="v" v-viewer>
        <img
          :src="`${apiUrl}/v1/cache/image/${v}.png`"
          :width="96"
          :max-width="96"
          :height="128"
          class="img"
          style="width: 96px; height: 128px; object-fit: cover"
        />
        <div class="removeLink" v-if="editMode">
          <a @click="remove(v)">Retirer</a>
        </div>
      </div>
    </template>
    <template v-else>
      <div
        class="file"
        :style="{ cursor: 'pointer' }"
        v-for="v in value"
        :key="v._id"
        @click="fetchFile(v._id)"
      >
        {{ v.name }}
        <div class="removeLink" v-if="editMode">
          <a @click.stop="remove(v)">Retirer</a>
        </div>
      </div>
    </template>
    <div
      class="drop-zone"
      ref="drop"
      @click="uploadPopup()"
      :class="{ 'is-file': type === 'files', 'read-only': !editMode }"
    >
      <input
        type="file"
        id="fileInput"
        ref="fileInput"
        style="display: none"
        @change="uploadFilesFromPopup"
        multiple
      />
      <v-icon style="pointer-events: none">cloud_upload</v-icon>
      <span style="pointer-events: none">Ajouter</span>
    </div>
  </div>
</template>

<script>
import { API_URL } from "../../../../webapp-commons/config";
import { fetchHil } from "../../utils";
import { downloadFile } from "../../../../webapp-commons/functions";

export default {
  name: "DropZone",
  props: {
    value: {},
    editMode: {},
    scrollable: {},
    type: { default: "image" },
    target: { default: null },
  },
  data() {
    return {
      apiUrl: API_URL,
    };
  },
  methods: {
    upload: function (file) {
      const formData = new FormData();
      if (this.target != null) {
        formData.append("target", this.target);
      }
      formData.append("file", file, file.name);
      const xhr = new XMLHttpRequest();
      xhr.open(
        "POST",
        `${process.env.VUE_APP_BASEURL}/cache/upload?type=${this.type}`,
        true
      );
      xhr.withCredentials = true;
      xhr.setRequestHeader("Authorization", localStorage.getItem("hil_token"));
      return new Promise((resolve, reject) => {
        xhr.onload = function () {
          if (xhr.status === 200) {
            resolve(xhr.response);
          } else if (xhr.status === 413) {
            alert("Le fichier est trop gros (maxi 16Mo)");
            reject(xhr.response);
          } else {
            alert("Une erreur a eu lieu");
            console.error(
              "can't upload " +
                name +
                " reason:" +
                xhr.statusText +
                xhr.statusText
            );
            reject(xhr.response);
          }
        };
        xhr.onerror = function () {
          alert("Une erreur a eu lieu");
          reject();
        };
        xhr.send(formData);
      });
    },
    uploadPopup() {
      this.$refs.fileInput.click();
    },
    remove(v) {
      const value = this.value.filter((x) => x !== v);
      this.$emit("input", value);
      this.$emit("remove", v);
    },
    async uploadFilesFromPopup(e) {
      const files = e.target.files;
      for (let f of files) {
        const id = await this.upload(f);
        this.$emit("input", [...this.value, `${id}`]);
      }
      this.$emit("add");
    },
    async fetchFile(id) {
      const data = await fetchHil(`/cache/file/${id}`);
      await downloadFile(data);
    },
  },
  async mounted() {
    /*
              Listen to all of the drag events and bind an event listener to each
              for the fileform.
            */
    [
      "drag",
      "dragstart",
      "dragend",
      "dragover",
      "dragenter",
      "dragleave",
      "drop",
    ].forEach(
      function (evt) {
        /*
                  For each event add an event listener that prevents the default action
                  (opening the file in the browser) and stop the propagation of the event (so
                  no other elements open the file in the browser)
                */
        this.$refs.drop.addEventListener(
          evt,
          function (e) {
            e.preventDefault();
            e.stopPropagation();
          }.bind(this),
          false
        );
      }.bind(this)
    );

    this.$refs.drop.addEventListener("dragenter", async (e) => {
      this.$refs.drop.classList.add("drop-over");
    });

    this.$refs.drop.addEventListener("dragleave", async (e) => {
      this.$refs.drop.classList.remove("drop-over");
    });

    this.$refs.drop.addEventListener("drop", async (e) => {
      for (let file of e.dataTransfer.files) {
        const id = await this.upload(file);
        this.$emit("input", [...this.value, `${id}`]);
        this.$emit("add");
      }
    });
  },
};
</script>

<style scoped>
.drop-area {
  width: 100%;
  overflow: hidden;
  flex-wrap: wrap;
}

.drop-zone {
  border: 1px dashed black;
  border-radius: 5px;
  height: 128px;
  display: flex;
  width: 96px;
  margin: 10px 5px 5px 0;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 9px;
  cursor: pointer;
}

.drop-zone.is-file {
  height: auto;
}

.read-only {
  display: none;
}

.drop-zone.drop-over {
  background: yellow;
}

.img {
  border-radius: 5px;
  margin: 5px 5px 5px 0;
}

.file {
  border-radius: 5px;
  margin: 5px 5px 5px 0;
  border: 1px solid #777;
  color: #777;
  padding: 5px;
}

.removeLink {
  text-align: center;
  font-size: 10px;
  padding-right: 5px;
}

.d-flex-initial > * {
  flex: initial !important;
}

#fileInput {
  visibility: hidden;
  overflow: hidden;
  height: 1px;
}

.drop-area-scrollable {
  flex-wrap: nowrap;
  overflow: auto;
}

.file-read-only {
  cursor: pointer;
}
</style>
